/* DropAvanzado · Pulso sutil en ATC tras inactividad */
(function() {
  var IDLE_MS = 5000;
  var idleTimer = null;

  function getAtcButtons() {
    return document.querySelectorAll(
      '.product-form__submit, button[name="add"], .da-sticky-atc button, [data-atc-button]'
    );
  }

  function startPulse() {
    getAtcButtons().forEach(function(btn) {
      if (!btn.disabled) btn.classList.add('da-pulse');
    });
  }

  function stopPulse() {
    getAtcButtons().forEach(function(btn) {
      btn.classList.remove('da-pulse');
    });
  }

  function resetIdle() {
    stopPulse();
    clearTimeout(idleTimer);
    idleTimer = setTimeout(startPulse, IDLE_MS);
  }

  ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(function(evt) {
    window.addEventListener(evt, resetIdle, { passive: true });
  });

  // Iniciar el temporizador al cargar
  resetIdle();

  // Respetar prefers-reduced-motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    clearTimeout(idleTimer);
  }
})();

/* Hero direct-to-cart */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-hero-atc]');
  if (!btn) return;
  
  var variantId = btn.getAttribute('data-hero-atc');
  btn.disabled = true;
  btn.textContent = 'AGREGANDO...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    // Abrir el cart drawer si existe
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.open) {
      drawer.open();
    } else {
      window.location.href = '/cart';
    }
  })
  .catch(function() {
    btn.disabled = false;
    btn.textContent = 'AGREGAR AL CARRITO →';
  });
});

/* Upsells 1-clic en cart drawer */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-upsell-add]');
  if (!btn) return;
  
  var variantId = btn.getAttribute('data-upsell-add');
  btn.disabled = true;
  btn.textContent = 'Agregando...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    // Refrescar el drawer
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.renderContents) {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        drawer.renderContents(cart);
      });
    } else {
      window.location.reload();
    }
  });
});
